export default {
    orders:{
        orderInformation:"Payment Details",
        theAmountToBePaid:"Payment Amount",
        orderNumber:"Ticket",
        tipstitle:"Notice",
        remainingPaymentTime:"Expiration Time",
        copy:"Copy Address",
        theReplicationIsSuccessful:"Copy successful.",
        tips:{
            first:"1、Please do not pay after the order expires, otherwise it will not be deposited and refund.",
            second:"2、Blockchain transfers will only be credited after a certain number of blocks have been confirmed. Please be patient.",
            third:"3、Please note whether the platform you are using to send USDT charges any fees, as this may affect the actual amount receive.",
            fourth:"4、Please make sure your device and browser are secure to prevent messages from being tampered with or leaked.",
        }
    }

}
